import type { jsPDF } from 'jspdf';

import type { AlineFontName, LeafFontStyle } from '../../../slate-api';
import { isAlineFontName } from '../../../slate-api';
import { pxToPt } from '../../../util';

export function setPDFTextFont(
  pdf: jsPDF,
  { fontSizePx, fontStyle, fontType, fontWeight }: LeafFontStyle
) {
  // Only use supported fonts
  const safeFontName: AlineFontName = isAlineFontName(fontType) ? fontType : 'Times New Roman';
  pdf.setFont(safeFontName, fontStyle, fontWeight);
  pdf.setFontSize(pxToPt(fontSizePx));
}
